module.exports = __webpack_public_path__ + "static/car-a59f233433c82ba63563e730f503d17e.svg";